import AuthorInfo from './AuthorInfo';

const bookChapterArr = [
	{
		authors: [
			AuthorInfo.dev,
			AuthorInfo.ingo,
			AuthorInfo.michael,
			AuthorInfo.srini
		],
		title:
			'The bird gets caught by the WORM: tracking multiple deformable objects in noisy environments using Weight ORdered logic Maps',
		publisher:
			'Bebis G. et al. (eds) Advances in Visual Computing. Lecture Notes in Computer Science, vol 11241. [Springer, Cham]',
		abstract:
			'Object detection and tracking are active and important research areas in computer vision as well as neuroscience. Of particular interest is the detection and tracking of small, poorly lit, deformable objects in the presence of sensor noise, and large changes in background and foreground illumination. Such conditions are frequently encountered when an animal moves in its natural environment, or in an experimental arena. The problems are exacerbated with the use of high-speed video cameras as the exposure time for high-speed cameras is limited by the frame rate, which limits the SNR. In this paper we present a set of simple algorithms for detecting and tracking multiple, small, poorly lit, deformable objects in environments that feature drastic changes in background and foreground illumination, and poor signal-to-noise ratios. These novel algorithms are shown to exhibit better performance than currently available state-of-the art algorithms.',
		url: 'https://link.springer.com/chapter/10.1007/978-3-030-03801-4_30',
		researchGate:
			'https://www.researchgate.net/publication/328847754_The_Bird_Gets_Caught_by_the_WORM_Tracking_Multiple_Deformable_Objects_in_Noisy_Environments_Using_Weight_ORdered_Logic_Maps_13th_International_Symposium_ISVC_2018_Las_Vegas_NV_USA_November_19_-_21_201'
	}
];

export default bookChapterArr;
